module.exports = __webpack_public_path__ + "media/images/mobile/home/banner1-1ab0ed4a9d05f598e206bbafadff7c5f.jpg";